import React from "react";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import CONFIG from "../../../utils/config";
import _ from "lodash";
import {
  getCoursesWithHigherSubscription,
  getCoursesWithHigherSubscriptionClear,
  getCoursesWithPaidSubscription,
  getCoursesWithPaidSubscriptionClear,
  getProductCategoriesData,
  getProductCategoriesDataClear,
} from "../../../redux/courses/actions";
import {
  PriceForSession,
  ProductCardPriceInfo,
  PurchasedOn,
  SessionKeys,
  convertMinutesToHoursAndMinutes,
  convertSecondsToMins,
  convertTimeFormat,
  getProcureInfo,
  redirectToPageUtil,
} from "../../../utils/AppUtils";
import { useNavigate } from "react-router";
import CommonComponentEntity from "./CommonComponentEntity";
import useLogin from "../../../custom-hooks/useLogin";
import { useTranslation } from "react-i18next";

const CoursesIncludedWithSubscription = ({ fetchData, currentSubscription,is_home, from_sub }) => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
const {t} = useTranslation();
  const coursesIncludedWithSubscription = useSelector(
    (state) => state.courses.coursesWithPaidSubscription
  );
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (fetchData) getCoursesWithPaidSubscriptionData();

    return () => {
      dispatch(getCoursesWithPaidSubscriptionClear());
    };
  }, [fetchData]);

  const [newCardData, setNewCardData] = useState(
    CONFIG.INITIAL_PRODUCT_CARD_DATA
  );

  const [paidUserCount, setPaidUserCount] = useState(0);
  const { isLoggedIn } = useLogin();
  const authBroker = useSelector((state) => state.auth.authBroker);

  const [courseData, setCourseData] = useState({});

  const formatProductCardData = (coursesList) => {
    let prodArr = [];
    for (let course of coursesList) {
      let tags = [];
      let btnTitle = t("Start course");
      if (course.provider?.provider_display_name) {
        tags.push(course.provider.provider_display_name);
      }
      tags.push("Course");

      if (course.lessons) {
        tags.push(`${course.lessons} Module${course.lessons > 1 ? "s" : ""}`);
      }

      if (course?.duration) {
        tags.push(convertTimeFormat(course.duration, true));
      }

      if (course?.crs_progress > 0 && course?.crs_progress < 100) {
        btnTitle = t("Resume course");
      } else if (course?.crs_progress >= 100) {
        btnTitle = t("Revisit course");
      }

      let priceInfo = getProcureInfo(course?.purchased_info);
      course.priceInfo = priceInfo;
      course.isLoggedIn = isLoggedIn;
      course.is_home = is_home;
      course.from_sub = from_sub;
      course.provider_id = "";

      prodArr.push({
        id: course?.id,
        is_like: course?.is_like ? course?.is_like : false,
        is_bookmark: course?.is_bookmark ? course?.is_bookmark : false,
        is_wishlist: course?.is_addtowishlist,
        dbId: course?.list_id,
        productType: "course",
        productOrigin: course?.source,
        title: course?.name,
        logoURL: course.provider?.provider_img
          ? course.provider?.provider_img
          : "",
        bannerURL: course?.imageURL,
        tagsArray: tags,
        description: course?.short_description,
        btnTitle: btnTitle,
        progress: course?.crs_progress,
        showLikeMenu: true,
        btnAction: () =>
          redirectToPageUtil(
            course,
            navigate,
            authBroker,
            setCourseData,
            dispatch
          ),
        descAction: {},
        bannerAction: () =>
          redirectToPageUtil(
            course,
            navigate,
            authBroker,
            setCourseData,
            dispatch
          ),
        footerLineComp: !_.isEmpty(priceInfo)
          ? ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor)
          : "",
        showHeader: true,
        showProviderIcon: true,
        showBody: course?.short_description ? true : false,
        showFooter: true,
        showProgress: _.toNumber(course.crs_progress) > 0 ? true : false,
        cardClassName: "",
        rightBtnIcon: "/images/arrow-right.svg",
        lefttBtnIcon: "",
        isLoading: false,
        priceInfo
      });
    }
    console.log("PROD ARR", prodArr);
    setNewCardData(prodArr);
  };

  useEffect(() => {
    if (!_.isEmpty(coursesIncludedWithSubscription)) {
      if (coursesIncludedWithSubscription.status === "success") {
        const list1 =
          coursesIncludedWithSubscription.payload.payload?.courseList;
        if (!_.isEmpty(list1)) {
          setPaidUserCount(
            coursesIncludedWithSubscription.payload.payload?.user_count
          );
          formatProductCardData(list1);
          setIsLoading(false);
        } else {
          setNewCardData([]);
          setIsLoading(false);
        }
      } else {
        setNewCardData([]);
        setIsLoading(false);
      }
    }
  }, [coursesIncludedWithSubscription]);

  const getCoursesWithPaidSubscriptionData = () => {
    setNewCardData(CONFIG.INITIAL_PRODUCT_CARD_DATA);
    setIsLoading(true);
    dispatch(
      getCoursesWithPaidSubscription({
        module: "coursesWithPaidSubscription",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            ? localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            : "",
        },
      })
    );
  };

  useEffect(() => {
    setNewCardData(CONFIG.INITIAL_PRODUCT_CARD_DATA);
  }, []);

  return (
    <>
      <CommonComponentEntity
        newCardData={newCardData}
        heading={`Courses included with ${
          currentSubscription ? currentSubscription : ""
        }  subscription`}
        subHeading={`👍🏻  ${paidUserCount}+ learners have subscribed`}
        viewAllAction={"/learn/courses?tab=1"}
        type={"course"}
      />
    </>
  );
};

export default CoursesIncludedWithSubscription;
